import React, { useState } from "react";
import { MdLock } from "react-icons/md";
import { theme } from "../../theme";
import { StyledAccordion } from "./styled";

interface Props {
  title: string;
  body: React.ReactNode;
  disabled?: boolean;
  helperText?: string;
}

const Accordion: React.FC<Props> = ({ title, body, disabled, helperText }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <StyledAccordion disabled={disabled}>
        <button
          onClick={() => {
            if (disabled) return;
            setOpen(!open);
          }}
        >
          {disabled && <MdLock />} {title}
        </button>
        {!disabled && (
          <div className={open ? "body-open" : "body-close"}>{body}</div>
        )}
      </StyledAccordion>
      {helperText && (
        <small
          style={{
            display: "block",
            alignSelf: "flex-start",
            marginTop: "5px",
            fontSize: "12px",
            color: theme.textColor.quaternaryGray,
          }}
        >
          {helperText}
        </small>
      )}
    </>
  );
};

export default Accordion;
